import styled from 'styled-components';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${props => props.small ? 'unset' : '190px'};
  padding: ${props => props.outlined ? '5px 18px' : props.small ? '6px 19px' : props.rounded ? '11px 20px' : '7px 20px'};
  font-size: ${props => props.small ? '12px' : props.fontBig ? '16px' : '14px'};
  font-weight: bold;
  line-height: 1.5;
  color: ${props => props.outlined ? props.theme.main : '#fff'};
  outline: none;
  border: ${props => props.outlined ? `1px solid ${props.theme.main}` : 'none'};
  border-radius: ${props => props.rounded ? '50px' : '5px'};
  background: ${props => props.outlined ? '#fff' : 'linear-gradient(90deg, #6C90FF 0%, #8566FF 100%)'};
  transition: .3s ease-in;
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  opacity: ${props => props.disabled ? '0.5' : '1'};
  &:hover {
    background: linear-gradient(90deg, #6C90FF 0%, #8566FF 100%);
    color: #fff;
  }
  .btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-inline-start: 25px;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    background: #9175FF;
    transform: ${props => props.rtl ? 'none' : 'rotate(180deg)'};
    box-shadow: 0 3px 25px rgba(76, 18, 171, .81);
  }
`;

// TODO: this is grate component, let's move it to the UI folder
export default function Button({children, type, onClick, className = '', outlined, rounded = true, small, disabled, rtl, fontBig, considerForArrowInCircle}) {
    return (
        <StyledButton
            type={type}
            className={`${className} app-btn`}
            onClick={onClick}
            outlined={outlined}
            rounded={rounded}
            small={small}
            fontBig={fontBig}
            disabled={disabled}
            considerForArrowInCircle={considerForArrowInCircle}
            rtl={rtl}
        >
            {children}
        </StyledButton>
    )
}
